export var SearchPageEvents;
(function (SearchPageEvents) {
    /**
     * Identifies the search event that gets logged when the initial query is performed as a result of loading a search interface.
     */
    SearchPageEvents["interfaceLoad"] = "interfaceLoad";
    /**
     * Identifies the search event that gets logged when a new tab is selected in the search interface.
     */
    SearchPageEvents["interfaceChange"] = "interfaceChange";
    /**
     * Identifies the search event that gets logged when `enableAutoCorrection: true` and the query is automatically corrected.
     */
    SearchPageEvents["didYouMeanAutomatic"] = "didYouMeanAutomatic";
    /**
     * Identifies the search event that gets logged when the query suggestion with the corrected term is selected and successfully updates the query.
     */
    SearchPageEvents["didYouMeanClick"] = "didYouMeanClick";
    /**
     * Identifies the search event that gets logged when a sorting method is selected.
     */
    SearchPageEvents["resultsSort"] = "resultsSort";
    /**
     * Identifies the search event that gets logged when a submit button is selected on a search box.
     */
    SearchPageEvents["searchboxSubmit"] = "searchboxSubmit";
    /**
     * The search-as-you-type event that gets logged when a query is automatically generated, and results are displayed while a user is entering text in the search box before they voluntarily submit the query.
     */
    SearchPageEvents["searchboxAsYouType"] = "searchboxAsYouType";
    /**
     * The event that gets logged when a breadcrumb facet is selected and the query is updated.
     */
    SearchPageEvents["breadcrumbFacet"] = "breadcrumbFacet";
    /**
     * Identifies the search event that gets logged when the event to clear the current breadcrumbs is triggered.
     */
    SearchPageEvents["breadcrumbResetAll"] = "breadcrumbResetAll";
    /**
     * Identifies the click event that gets logged when a user clicks a search result to open an item.
     */
    SearchPageEvents["documentOpen"] = "documentOpen";
    /**
     * Identifies the search event that gets logged when a user clicks a query suggestion based on the usage analytics recorded queries.
     */
    SearchPageEvents["omniboxAnalytics"] = "omniboxAnalytics";
    /**
     * Identifies the search event that gets logged when a suggested search query is selected from a standalone searchbox.
     */
    SearchPageEvents["omniboxFromLink"] = "omniboxFromLink";
    /**
     * Identifies the search event that gets logged when the search page loads with a query, such as when a user clicks a link pointing to a search results page with a query or enters a query in a standalone search box that points to a search page.
     */
    SearchPageEvents["searchFromLink"] = "searchFromLink";
    /**
     * Identifies the custom event that gets logged when a user action triggers a new query set in the effective query pipeline on the search page.
     */
    // oxlint-disable-next-line typescript/no-duplicate-enum-values
    SearchPageEvents["triggerQuery"] = "query";
    /**
     * Identifies the search cause that gets logged for pagination and other user navigation that do not express a new search intent.
     */
    SearchPageEvents["browseResults"] = "browseResults";
    /**
     * Identifies the search event that gets logged when a static filter check box is deselected and the query is updated.
     */
    SearchPageEvents["staticFilterDeselect"] = "staticFilterDeselect";
    /**
     * Identifies the search event that gets logged when the Clear Facet button is selected.
     */
    SearchPageEvents["facetClearAll"] = "facetClearAll";
    /**
     * Identifies the search event that gets logged when a facet check box is selected and the query is updated.
     */
    SearchPageEvents["facetSelect"] = "facetSelect";
    /**
     * Identifies the search event that gets logged when a facet check box is deselected and the query is updated.
     */
    SearchPageEvents["facetDeselect"] = "facetDeselect";
    /**
     * Identifies the search event that gets logged when a user clicks a facet value to filter out results containing the facet value.
     */
    SearchPageEvents["facetExclude"] = "facetExclude";
    /**
     * Identifies the search event that gets logged when a user clicks a facet value to not filter out results containing the facet value.
     */
    SearchPageEvents["facetUnexclude"] = "facetUnexclude";
    /**
     * Identifies the search event that gets logged when the sort criteria on a facet is updated.
     */
    SearchPageEvents["facetUpdateSort"] = "facetUpdateSort";
    /**
     * Identifies the search event that gets logged when the document suggestions are fetched.
     */
    SearchPageEvents["documentSuggestion"] = "documentSuggestion";
    /**
     * The custom event that gets logged when an end-user expands a facet to see additional values.
     */
    SearchPageEvents["facetShowMore"] = "showMoreFacetResults";
    /**
     * The custom event that gets logged when an end-user collapses a facet to see less values.
     */
    SearchPageEvents["facetShowLess"] = "showLessFacetResults";
    /**
     * Identifies the custom event that gets logged when a user query encounters an error during execution.
     */
    SearchPageEvents["queryError"] = "query";
    /**
     * Identifies the search event that gets logged when a user action (that is not a query) reloads the Recommendations panel with new recommendations.
     */
    SearchPageEvents["recommendationInterfaceLoad"] = "recommendationInterfaceLoad";
    /**
     * Identifies the custom event that gets logged when a user identifies a smart snippet answer as relevant.
     */
    SearchPageEvents["likeSmartSnippet"] = "likeSmartSnippet";
    /**
     * Identifies the custom event that gets logged when a user identifies a smart snippet answer as irrelevant.
     */
    SearchPageEvents["dislikeSmartSnippet"] = "dislikeSmartSnippet";
    /**
     * Identifies the custom event that gets logged when a user expand a smart snippet answer.
     */
    SearchPageEvents["expandSmartSnippet"] = "expandSmartSnippet";
    /**
     * Identifies the custom event that gets logged when a user collapse a smart snippet answer.
     */
    SearchPageEvents["collapseSmartSnippet"] = "collapseSmartSnippet";
    /**
     * Identifies the custom event that gets logged when a user open a smart snippet explanation modal for feedback.
     */
    SearchPageEvents["openSmartSnippetFeedbackModal"] = "openSmartSnippetFeedbackModal";
    /**
     * Identifies the custom event that gets logged when a user close a smart snippet explanation modal for feedback.
     */
    SearchPageEvents["closeSmartSnippetFeedbackModal"] = "closeSmartSnippetFeedbackModal";
    /**
     * Identifies the custom event that gets logged when a user sends an explanation for a smart snippet irrelevant answer.
     */
    SearchPageEvents["sendSmartSnippetReason"] = "sendSmartSnippetReason";
    /**
     * Identifies the custom event that gets logged when a snippet suggestion for a related question is expanded.
     */
    SearchPageEvents["expandSmartSnippetSuggestion"] = "expandSmartSnippetSuggestion";
    /**
     * Identifies the custom event that gets logged when a snippet suggestion for a related question is collapsed.
     */
    SearchPageEvents["collapseSmartSnippetSuggestion"] = "collapseSmartSnippetSuggestion";
    /**
     * Identifies the custom event that gets logged when a user clicks the source of an answer in a smart snippet.
     */
    SearchPageEvents["openSmartSnippetSource"] = "openSmartSnippetSource";
    /**
     * Identifies the custom event that gets logged when a user clicks the source of a snippet suggestion for a related question.
     */
    SearchPageEvents["openSmartSnippetSuggestionSource"] = "openSmartSnippetSuggestionSource";
    /**
     * Identifies the click event that gets logged when a user clicks the Show More link under a search result that support the folding component.
     */
    SearchPageEvents["showMoreFoldedResults"] = "showMoreFoldedResults";
    /**
     * Identifies the custom event that gets logged when a user clicks the Show Less link under a search result that support the folding component.
     */
    SearchPageEvents["showLessFoldedResults"] = "showLessFoldedResults";
    /**
     * Identifies the click event that gets logged when a user clicks the Copy To Clipboard result action.
     */
    SearchPageEvents["copyToClipboard"] = "copyToClipboard";
    /**
     * Identifies the click event that gets logged when a user clicks the Send As Email result action.
     */
    SearchPageEvents["caseSendEmail"] = "Case.SendEmail";
    /**
     * Identifies the click event that gets logged when a user clicks the Post To Feed result action.
     */
    SearchPageEvents["feedItemTextPost"] = "FeedItem.TextPost";
    /**
     * Identifies the click event that gets logged when a user clicks the Attach To Case result action.
     */
    SearchPageEvents["caseAttach"] = "caseAttach";
    /**
     * Identifies the custom event that gets logged when a user clicks the Detach From Case result action.
     */
    SearchPageEvents["caseDetach"] = "caseDetach";
    /**
     * Identifies the click event that gets logged when a user attaches a generated answer citation to a case.
     */
    SearchPageEvents["generatedAnswerCitationDocumentAttach"] = "generatedAnswerCitationDocumentAttach";
    /**
     * Identifies the cause of a search request being retried in order to regenerate an answer stream that failed.
     */
    SearchPageEvents["retryGeneratedAnswer"] = "retryGeneratedAnswer";
    /**
     * Identifies the custom event that gets logged when a user identifies a generated answer as relevant.
     */
    SearchPageEvents["likeGeneratedAnswer"] = "likeGeneratedAnswer";
    /**
     * Identifies the custom event that gets logged when a user identifies a generated answer as irrelevant.
     */
    SearchPageEvents["dislikeGeneratedAnswer"] = "dislikeGeneratedAnswer";
    /**
     * Identifies the custom event that gets logged when a user opens a generated answer citation.
     */
    SearchPageEvents["openGeneratedAnswerSource"] = "openGeneratedAnswerSource";
    /**
     * Identified the custom event that gets logged when a generated answer stream is completed.
     */
    SearchPageEvents["generatedAnswerStreamEnd"] = "generatedAnswerStreamEnd";
    /**
     * Identifies the search event that gets logged when the query context is updated as a result of updating one of the case context fields.
     */
    SearchPageEvents["contextChanged"] = "contextChanged";
    /**
     * Identifies the custom event that gets logged when a user hovers over a generated answer citation.
     */
    SearchPageEvents["generatedAnswerSourceHover"] = "generatedAnswerSourceHover";
    /**
     * Identifies the custom event that gets logged when a user submits feedback on a generated answer.
     */
    SearchPageEvents["generatedAnswerFeedbackSubmit"] = "generatedAnswerFeedbackSubmit";
    /**
     * Identifies the custom event that gets logged when a user deactivates the RGA feature.
     */
    SearchPageEvents["generatedAnswerHideAnswers"] = "generatedAnswerHideAnswers";
    /**
     * Identifies the custom event that gets logged when a user activates the RGA feature.
     */
    SearchPageEvents["generatedAnswerShowAnswers"] = "generatedAnswerShowAnswers";
    /**
     * Identifies the custom event that gets logged when a user expands a generated answer.
     */
    SearchPageEvents["generatedAnswerExpand"] = "generatedAnswerExpand";
    /**
     * Identifies the custom event that gets logged when a user collapses a generated answer.
     */
    SearchPageEvents["generatedAnswerCollapse"] = "generatedAnswerCollapse";
    /**
     * Identifies the custom event that gets logged when a user clicks the copy to clipboard button of a generated answer.
     */
    SearchPageEvents["generatedAnswerCopyToClipboard"] = "generatedAnswerCopyToClipboard";
    /**
     * Identifies the custom event that gets logged when the user opens the full search page from the insight panel.
     */
    SearchPageEvents["expandToFullUI"] = "expandToFullUI";
    /**
     * Identifies the custom event that gets logged when the user clicks the create article button.
     */
    SearchPageEvents["createArticle"] = "createArticle";
    /**
     * Identifies the search event that gets logged when the user selects a recent query.
     */
    SearchPageEvents["recentQueriesClick"] = "recentQueriesClick";
    /**
     * Identifies the custom event that gets logged when the user clears the recent queries.
     */
    SearchPageEvents["clearRecentQueries"] = "clearRecentQueries";
})(SearchPageEvents || (SearchPageEvents = {}));
